function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wheel",
  transform: "rotate(90 10 9)",
  stroke: "#002D56"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 4.5,
  cx: 10.5,
  cy: 9.5,
  r: 5.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Axis-3",
  transform: "translate(7)",
  fill: "#002D56"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.268.5l-1.334 2h5.132L4.732.5H2.268z",
  id: "Toot-6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.268 16.5l-1.334 2h5.132l-1.334-2H2.268z",
  id: "Toot-5",
  transform: "matrix(1 0 0 -1 0 35)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Axis-2",
  transform: "rotate(60 7 15.562)",
  fill: "#002D56"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.268.5l-1.334 2h5.132L4.732.5H2.268z",
  id: "Toot-4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.268 16.5l-1.334 2h5.132l-1.334-2H2.268z",
  id: "Toot-3",
  transform: "matrix(1 0 0 -1 0 35)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Axis-1",
  transform: "rotate(-60 7 3.438)",
  fill: "#002D56"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.268.5l-1.334 2h5.132L4.732.5H2.268z",
  id: "Toot-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.268 16.5l-1.334 2h5.132l-1.334-2H2.268z",
  id: "Toot-1",
  transform: "matrix(1 0 0 -1 0 35)"
}))));

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };